import { isFictor } from './perfilFictor';
import { EnumTipoProposta, getLabelTipoProp, TipoPropostaValues, TiposProposta } from "./tiposProposta";

export const PROPOSTAS_POR_PRODUTO: Record<string, string[]> = isFictor ? {
  RCC_SAQUE: [EnumTipoProposta.CARTAO_SACADO, EnumTipoProposta.COMPRA_DIVIDA_SAQUE, EnumTipoProposta.SAQUE_REFIN],
  RCC_COMPRA: [EnumTipoProposta.CARTAO_SEM_SAQUE, EnumTipoProposta.COMPRA_DIVIDA, EnumTipoProposta.SAQUE_REFIN],
  CARTAO_CREDITO: [EnumTipoProposta.CARTAO_SACADO, EnumTipoProposta.COMPRA_DIVIDA, EnumTipoProposta.SAQUE_REFIN],
  EMPRESTIMO: [EnumTipoProposta.NOVO, EnumTipoProposta.COMPRA_DIVIDA, EnumTipoProposta.SAQUE_REFIN, EnumTipoProposta.PORTABILIDADE],
} : {
  CARTAO_BENEFICIO: [
    EnumTipoProposta.CARTAO_SACADO,
    EnumTipoProposta.CARTAO_SEM_SAQUE,
    EnumTipoProposta.SAQUE_COMPLEMENTAR,
    EnumTipoProposta.SAQUE_REFIN,
    EnumTipoProposta.COMPRA_DIVIDA_SAQUE,
  ],

  CARTAO_CREDITO: [
    EnumTipoProposta.CARTAO_SACADO,
    EnumTipoProposta.CARTAO_SEM_SAQUE,
    EnumTipoProposta.SAQUE_COMPLEMENTAR,
    EnumTipoProposta.SAQUE_REFIN,
  ],

  ANTECIPACAO_REMUNERACAO: [
    EnumTipoProposta.NOVO,
  ],

  EMPRESTIMO: [
    EnumTipoProposta.NOVO,
    //EnumTipoProposta.COMPRA_DIVIDA,
  ],
};

export const getPropostasPorProduto = (tipo: string) => {
  const permitidas = PROPOSTAS_POR_PRODUTO[tipo] || [];
  return isFictor
    ? permitidas.map(value => ({ value: value as TipoPropostaValues, label: getLabelTipoProp(value) }))
    : TiposProposta.filter(item => permitidas.includes(item.value));
};
